// BNB
export const DEFAULT_INPUT_CURRENCY = 'BNB'
// BUSD
export const DEFAULT_OUTPUT_CURRENCY = '0xe4e8e6878718bfe533702D4a6571Eb74D79b0915'
